<template>
  <b-container>
    <div class="schools">
      <h1>Schools</h1>
      <div v-if="!isLoading" class="table-wrap">
        <div>
          <router-link v-if="isAdmin" :to="{ name: 'NewSchool' }" class
            >+Add School</router-link
          >
        </div>
        <br />
        <b-row>
          <b-col v-if="isAdmin">
            <name-search table="schools" parent="schools-list"></name-search>
            <b-button @click="resetList" class="mb-2">Reset Search</b-button>
          </b-col>
          <b-col md="6">
            <b-form-group horizontal label="Sort">
              <b-input-group>
                <b-form-select v-model="sortBy" :options="sortOptions">
                  <option slot="first" :value="null">-- none --</option>
                </b-form-select>
                <b-form-select
                  :disabled="!sortBy"
                  v-model="sortDesc"
                  slot="append"
                >
                  <option :value="false">Asc</option>
                  <option :value="true">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6" class="my-1">
            <b-input-group>
              <b-form-input
                v-model="filter"
                placeholder="Type to Filter Schools"
              />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="schoolCount || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
              align="right"
            />
          </b-col>
        </b-row>
        <b-table
          v-cloak
          responsive
          :fields="fields"
          :items="schools"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
        >
          <template slot="cell(school_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditSchool', params: { id: row.item.uuid } }"
              >{{ row.value }}</b-link
            >
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="schoolCount"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
          <download-button :export="schools" :file="file"></download-button>
        </b-row>
      </div>
      <div v-else>
        <p>Schools are loading...</p>
        <b-spinner></b-spinner>
        <br />
        <router-link
          v-if="isAdmin"
          v-bind:to="{ name: 'NewSchool' }"
          class="add_school_link"
          >+Add School</router-link
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DownloadButton from "@/components/DownloadButton";
import NameSearch from "@/components/NameSearch";
import SchoolService from "@/services/SchoolService";

export default {
  name: "SchoolsList",
  components: {
    DownloadButton,
    NameSearch,
  },
  data() {
    return {
      file: this.$route.path.slice(1),
      fields: [
        { key: "school_name", label: "Name", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "region", label: "Region", sortable: true },
        { key: "district", label: "District", sortable: true },
      ],
      currentPage: 0,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      isLoading: true,
    };
  },
  methods: {
    ...mapActions({
      GET_SCHOOLS: "schools/GET_SCHOOLS",
      GET_SCHOOL_COUNT: "schools/GET_SCHOOL_COUNT",
      RESET_SCHOOLS_STATE: "schools/RESET_SCHOOLS_STATE",
      RESET_SEARCH_STATE: "searches/RESET_SEARCH_STATE",
    }),
    async resetList() {
      await this.RESET_SEARCH_STATE();
      await this.GET_SCHOOLS();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    stopClick(row) {},
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),
    schools: {
      get() {
        console.log("schools: ", this.$store.state.schools.schools);
        return this.$store.state.schools.schools;
      },
    },
    schoolCount: {
      get() {
        return this.$store.state.schools.schools.length || 0;
      },
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  watch: {
    currentPage: {
      handler(val) {
        SchoolService.fetchSchools(val, this.perPage).catch((err) =>
          console.error(err)
        );
      },
    },
  },
  async created() {
    await this.GET_SCHOOLS();
    await this.GET_SCHOOL_COUNT();
    this.isLoading = false;
  },
  destroyed() {
    this.RESET_SEARCH_STATE();
  },
};
</script>

<style scoped>
.table-wrap {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
table th,
table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_school_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}
</style>
